import { lightTheme as light } from './tokens/lightTheme';
import { darkTheme as dark } from './tokens/darkTheme';
const themes = {
    light,
    dark,
};
export const quickProperty = (value) => ({
    name: '',
    value,
});
export const customProp = (propName) => quickProperty(`var(--goto-${propName})`);
export const designToken = (tokenName) => {
    const result = {
        name: tokenName,
        attributes: {},
    };
    Object.keys(themes).forEach((themeName) => {
        const theme = themes[themeName];
        result.attributes[themeName] = theme[tokenName];
    });
    return result;
};
